"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var umap_1 = require("./umap");
Object.defineProperty(exports, "UMAP", { enumerable: true, get: function () { return umap_1.UMAP; } });
